module.exports = __webpack_public_path__ + "img/amrosen.94210586.jpg";